export default __webpack_public_path__ + "static/media/ml.11f1f6c3.jpg";